$(function() {

    //Set site lang on page load
    if(!docCookies.hasItem('site_lang')) {
        docCookies.setItem('site_lang', 'english');
    }

    $('.nav__link').on('click', function(e) {
        e.preventDefault();

        $('.header__mobile-nav').fadeOut(200);
        $('body').removeClass('fullscreen');

        var id = $(this).attr('href');
        scroll_to_pos(get_element_pos($(id)) - 30, 600);
    });

    $('.header__mobile-bars').on('click', function(e) {
        e.preventDefault();

        scroll_to_pos(0, 300);
        $('.header__mobile-nav').fadeIn(200);
        $('body').addClass('fullscreen');
    });

    $('.header__mobile-nav > span').on('click', function(e) {
        e.preventDefault();

        $('.header__mobile-nav').fadeOut(200);
        $('body').removeClass('fullscreen');
    });

    $('.header__lang select').on('change', function(e) {
        e.preventDefault();

        //Set site lang when toggled
        docCookies.setItem('site_lang', $(this).val());

        //Reload page
        window.location.reload();

    });

});